import React from "react";
import { useTranslation } from "react-i18next";
import { Svg } from "@whatslly/ui-components/v2/BaseElements/Svg";
import styles from "./ErrorBox.module.scss";

export const ErrorBox: React.FC<{ error: string; testId?: string; tryAgain?: React.ReactNode }> = ({ error, testId, tryAgain }) => {
  const { t } = useTranslation();
  return (
    <div data-testid={testId} className={styles.error}>
      <Svg iconName="unknown-issue" />
      <div className={styles.errorMessage}>{error}</div>
      <div className={styles.tryAgain}>{tryAgain ?? t("error_try_again")}</div>
    </div>
  );
};
